import { DeleteIcon } from '@medeloop/medeloop-components-library';
import DataTable from '@medeloop/medeloop-components-library/dist/components/DataTable';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { TooltipButton } from 'src/components';
import { StudyResearcher, UserStudyRole } from 'src/types/studies';

interface StudyResearchersTableProps {
  researchers: StudyResearcher[];
  allowActions?: boolean;
}

export function StudyResearchersTable({ researchers, allowActions }: StudyResearchersTableProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleUnassignResearcher = (researcher: StudyResearcher) => {
    navigate({
      pathname: 'actions',
      search: `?${createSearchParams({
        action: 'UNASSIGN_RESEARCHER',
        id: researcher.studyId,
        userId: researcher.userId,
        role: UserStudyRole.RESEARCHER,
        name: researcher.studyName,
      })}`,
    });
  };

  return (
    <DataTable className="px-6 py-4">
      <DataTable.Header>
        <DataTable.HeaderCell>{t('first_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('last_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('email_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('role_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell />
      </DataTable.Header>
      <DataTable.Body className="h-96 overflow-auto">
        {researchers.length > 0 ? (
          researchers.map((researcher: StudyResearcher) => (
            <DataTable.Row key={researcher.userId}>
              <DataTable.RowCell align="center">{researcher.researcherGivenName}</DataTable.RowCell>
              <DataTable.RowCell align="center">
                {researcher.researcherFamilyName}
              </DataTable.RowCell>
              <DataTable.RowCell align="center">{researcher.researcherEmail}</DataTable.RowCell>
              <DataTable.RowCell align="center">
                {researcher.isManager ? 'Manager' : t('researcher')}
              </DataTable.RowCell>
              <DataTable.RowCell align="center">
                {allowActions && (
                  <TooltipButton
                    tooltipText={t('unassign_researcher')}
                    onClick={() => handleUnassignResearcher(researcher)}
                  >
                    <DeleteIcon className="h-5 w-5" />
                  </TooltipButton>
                )}
              </DataTable.RowCell>
            </DataTable.Row>
          ))
        ) : (
          <div className="flex flex-grow items-center justify-center p-4">
            <p>{t('no_researchers_assigned_to_this_study')}</p>
          </div>
        )}
      </DataTable.Body>
    </DataTable>
  );
}
